import { render, staticRenderFns } from "./BfFooter.vue?vue&type=template&id=04421358&scoped=true&"
import script from "./BfFooter.vue?vue&type=script&lang=js&"
export * from "./BfFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04421358",
  null
  
)

export default component.exports